export const translationPath = (baseUrl, locale) => `${baseUrl}assets/locale/productPage/productPage_${locale}.json`;
export const widgetId = '13a94f09-2766-3c40-4a32-8edb5acdd8bc';
export const PRODUCT_PAGE_APP_NAME = 'wixstores-product-page';
export const QUICK_VIEW_APP_NAME = 'wixstores-product-page-quick-view';
export const PRODUCT_PAGE_WIXCODE_APP_NAME = 'wixstores-product-page-wixcode';

export const defaultFontSize = 16;

export const DEFAULT_IMAGE_SIZE = 100;

export const DEFAULT_PRODUCT_ITEM_ID = '00000000-0000-0000-0000-000000000000';

export const DASHBOARD_PAGE_ID = '0da20375-5aad-400a-abcb-e50e17308306';

export const CATEGORY_PAGE_URL_PREFIX = 'category';

export const enum ArrowsDir {
  LEFT = 'left',
  RIGHT = 'right',
  UP = 'up',
  DOWN = 'down',
}

export enum TabsDirection {
  start = 'left',
  end = 'right',
}

export const enum GalleryNavigationType {
  THUMBNAILS = 'thumbnails',
  DOTS = 'dots',
}

export const enum GalleryNavigationLocation {
  INSIDE = 'inside',
  OUTSIDE = 'outside',
}

export const enum GalleryNavigationPosition {
  BOTTOM = 'bottom',
  LEFT = 'left',
  RIGHT = 'right',
}

export const enum MediaNavArrowsDisplayMode {
  ALWAYS = 0,
  HOVER = 1,
}

export const enum LayoutId {
  EmptyState = 0,
  Classic = 1,
  QuickView = 2,
  Sleek = 4,
  Stunning = 5,
  Spotlight = 6,
  Simple = 7,
  Responsive = 8,
}

export const enum Layout {
  Classic = 'classic',
  EmptyState = 'empty-state',
  Mobile = 'mobile',
  QuickView = 'quickView',
  Responsive = 'responsive',
  Simple = 'simple',
  Sleek = 'sleek',
  Spotlight = 'spotlight',
  Stunning = 'stunning',
}

export enum InfoSectionLayoutId {
  Collapse = 1,
  Stacked = 3,
  Tabs = 2,
  Columns = 4,
}

export const enum MediaFrameMediaType {
  SECURE_PICTURE = 'secure_picture',
  SECURE_VIDEO = 'secure_video',
  SECURE_DOCUMENT = 'secure_document',
  SECURE_MUSIC = 'secure_music',
  SECURE_ARCHIVE = 'secure_archive',
}

export const enum ProductType {
  DIGITAL = 'digital',
  PHYSICAL = 'physical',
}

export const enum Alignment {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center',
  START = 'start',
  END = 'end',
}

export const enum ProductInventoryStatus {
  OUT_OF_STOCK = 'out_of_stock',
  IN_STOCK = 'in_stock',
}

export const enum ProductOptionType {
  COLOR = 'COLOR',
  DROP_DOWN = 'DROP_DOWN',
}

export const enum MediaType {
  PHOTO = 'PHOTO',
  VIDEO = 'VIDEO',
}

export interface IKeyboardEvent {
  keyCode: number;
  charCode: number;
}

export const keyboardEvents: {[key: string]: IKeyboardEvent} = {
  ENTER: {keyCode: 13, charCode: 13},
  SPACEBAR: {keyCode: 32, charCode: 13},
  ARROW_UP: {keyCode: 38, charCode: 38},
  ARROW_DOWN: {keyCode: 40, charCode: 40},
  ARROW_RIGHT: {keyCode: 39, charCode: 39},
  ARROW_LEFT: {keyCode: 37, charCode: 37},
};

export const enum SocialVendor {
  WhatsApp = 'whatsapp',
  Facebook = 'facebook',
  Twitter = 'twitter',
  Pinterest = 'pinterest',
  MobileNative = 'mobilenativeshare',
}

export const enum UserInputType {
  Selection = 'selection',
  Text = 'text',
  Quantity = 'quantity',
  SubscriptionPlan = 'subscriptionPlan',
}

export const enum productPagePanoramaEvent {
  ProductPageLoaded = 'product-page-loaded',
  AddToCart = 'add-to-cart',
  BuyNow = 'buy-now',
  Subscribe = 'subscribe',
  AddToWishlist = 'add-to-wishlist',
  RemoveFromWishlist = 'remove-from-wishlist',
  WixCodeGetProduct = 'wixcode-get-product',
  WixCodeGetProductId = 'wixcode-get-product-id',
  WixCodeGetCustomTextFieldValues = 'wixcode-get-custom-text-field-values',
  WixCodeGetCustomText = 'wixcode-get-custom-text',
  WixCodeGetQuantity = 'wixcode-get-quantity',
  WixCodeSetQuantity = 'wixcode-set-quantity',
  WixCodeOnQuantityChanged = 'wixcode-on-quantity-changed',
  WixCodeGetSelectedVariantId = 'wixcode-get-selected-variant-id',
  WixCodeGetSelectedChoices = 'wixcode-get-selected-choices',
  WixCodeOnChoiceSelected = 'wixcode-on-choice-selected',
  WixCodeOnAddToCart = 'wixcode-on-add-to-cart',
  WixCodeOnBuyNow = 'wixcode-on-buy-now',
}

export const enum productPageFedopsEvent {
  AddToCart = 'add-to-cart',
  BuyNow = 'buy-now',
  Subscribe = 'subscribe',
  WixCodeOnAddToCart = 'wixcode-on-add-to-cart',
  WixCodeOnBuyNow = 'wixcode-on-buy-now',
}

export const enum graphqlOperation {
  GetDefaultProduct = 'getDefaultProduct',
  GetCartService = 'getCartService',
  GetProductBySlug = 'getProductBySlug',
  GetProductById = 'getProductById',
  GetNextPrevProducts = 'getNextPrevProducts',
  GetStoreMetaData = 'getStoreMetaData',
  CreateCart = 'createCart',
  GetCountryCodes = 'getCountryCodes',
  GetCheckoutSettings = 'getCheckoutSettings',
  GetBackInStockSettings = 'getBackInStockSettings',
}

export const GRAPHQL_SOURCE = 'WixStoresWebClient';

export const MULTILINGUAL_TO_TRANSLATIONS_MAP = {
  ADD_TO_CART_BUTTON: 'PRODUCT_PAGE_BUTTON_TEXT',
  BUY_NOW_BUTTON: 'PRODUCT_PAGE_BUY_NOW_BUTTON_TEXT',
  PRODUCT_OUT_OF_STOCK_BUTTON: 'PRODUCT_PAGE_BUTTON_OOS_TEXT',
  'productPage.backInStock.notifyWhenAvailable.button': 'PRODUCT_PAGE_BUTTON_BIS_TEXT',
  PRODUCT_PAGE_SUBSCRIBE_NOW_BUTTON: 'productPage_subscribeButtonText',
  'wishlist.button': 'productPage_addWishlistButtonText',
  'wishlist.remove.button': 'productPage_removeWishlistButtonText',
};

export const COMPONENTS_ADD_TO_CART_TEXT_KEYS_OLD = [
  'quickView_addToCartButton',
  'PRODUCT_WIDGET_BUTTON_TEXT',
  'ADD_TO_CART_BUTTON_TEXT',
];

export const COMPONENTS_ADD_TO_CART_TEXT_KEYS = [
  'PRODUCT_WIDGET_BUTTON_TEXT',
  'PRODUCT_PAGE_BUTTON_TEXT',
  'ADD_TO_CART_BUTTON_TEXT',
];

export const COMPONENTS_OUT_OF_STOCK_TEXT_KEYS = ['gallery_oosButtonText', 'PRODUCT_PAGE_BUTTON_OOS_TEXT'];
export const COMPONENTS_BACK_IN_STOCK_TEXT_KEYS = ['PRODUCT_PAGE_BUTTON_BIS_TEXT'];
export const COMPONENTS_PRE_ORDER_TEXT_KEYS = ['PRODUCT_PAGE_BUTTON_PRE_ORDER_TEXT'];
export const COMPONENTS_PRE_ORDER_BUY_NOW_TEXT_KEYS = ['PRODUCT_PAGE_BUTTON_PRE_ORDER_BUY_NOW_TEXT'];

export const enum MarginBottom {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
}

export const enum ImageModeType {
  CROP = 'crop',
  FIT = 'fit',
}

export const LayoutNames = {
  [LayoutId.Classic]: 'classic',
  [LayoutId.EmptyState]: 'empty-state',
  [LayoutId.QuickView]: 'quickview',
  [LayoutId.Responsive]: 'responsive',
  [LayoutId.Simple]: 'simple',
  [LayoutId.Sleek]: 'sleek',
  [LayoutId.Spotlight]: 'spotlight',
  [LayoutId.Stunning]: 'stunning',
};

export const imageMobileWidth = 240;

export enum Origin {
  PRODUCT_PAGE = 'product-page',
  QUICK_VIEW = 'quick-view',
  STICKY_ADD_TO_CART = 'sticky add to cart',
}

export enum BiExposureTestName {
  PRODUCT_PAGE = 'product_page_loaded',
  QUICK_VIEW = 'quick_view_loaded',
}

export enum BiInventoryStatus {
  IN_STOCK = 'in_stock',
  OUT_OF_STOCK = 'out_of_stock',
  PARTIALLY = 'partially',
}

export enum SubscriptionPlansOneTimePurchaseOptionLocation {
  FIRST = 0,
  LAST = 1,
}
export enum ImageRatio {
  AUTO = -1,
  THREE_BY_TWO = 0,
  FOUR_BY_THREE = 1,
  ONE_BY_ONE = 2,
  THREE_BY_FOUR = 3,
  TWO_BY_THREE = 4,
}

export const BI_APP_NAME = 'productPageApp';

export enum PaymentOptionsBreakdownTheme {
  LIGHT = 1,
  DARK = 2,
}

export enum PaymentOptionsBreakdownThemeValue {
  DARK = 'dark',
  LIGHT = 'light',
}

export enum SocialShareIconsTheme {
  ORIGINAL = 0,
  DARK = 1,
  LIGHT = 2,
}

export enum AddToCartActionStatus {
  IDLE = 0,
  SUCCESSFUL = 1,
  FAILED = 2,
  IN_PROGRESS = 3,
}

export const BACK_IN_STOCK_MODAL_APP_NAME = 'back-in-stock-request-modal';
export const BACK_IN_STOCK_MODAL_OPENED_INTERACTION = 'open-request-modal';

export const slickAnimationSpeed = 400;

export enum ReviewsSlotIds {
  ProductPageDetailsSlot1 = 'product-page-details-slot-1',
  ProductPageBottomSlot = 'product-page-bottom-slot',
}

export enum ProductPageSlotIds {
  ProductPageTop = 'product-page-top',
  ProductPageAdditionalButtons = 'product-page-additional-buttons',
  ProductPageDetails1 = 'product-page-details-1',
  ProductPageDetails2 = 'product-page-details-2',
  ProductPageDetails3 = 'product-page-details-3',
  ProductPageDetails4 = 'product-page-details-4',
  ProductPageDetails5 = 'product-page-details-5',
  ProductPageDetails6 = 'product-page-details-6',
  ProductPageDetails7 = 'product-page-details-7',
  ProductPageDetails8 = 'product-page-details-8',
  ProductPageDetails9 = 'product-page-details-9',
  ProductPageMedia1 = 'product-page-media-1',
  ProductPageBottom = 'product-page-bottom',
}

export const STORES_NAMESPACE = 'stores';

export enum StickyColumnType {
  MEDIA = 0,
  INFO = 1,
}

export enum StickyButtonAction {
  ADD_TO_CART = 0,
  BUY_NOW = 1,
}

export enum ProductBorderStyleType {
  OUTLINE = 1,
  INLINE = 2,
}

export const enum TextualOptionType {
  DROPDOWN = 1,
  BUTTONS = 2,
}

export enum ButtonOptionWidth {
  FIT = 1,
  STRETCH = 2,
}

export enum RibbonStyle {
  RECTANGLE = 1,
  RECTANGLE_OUTLINE = 2,
  PILL = 3,
  PILL_OUTLINE = 4,
  TEXT = 5,
}

export enum RibbonType {
  RECTANGLE = 1,
  TEXT = 2,
}

export enum RibbonPlacement {
  OnImage = 1,
  ProductInfo = 2,
}

export enum MultipleRibbonsLayout {
  Horizontal = 0,
  Vertical = 1,
}
